import { useAuthentication } from 'hooks/authentication';
import { JsonEditor } from '../JsonEditor';
import { createCallback } from '../utils';

export const AuthenticationDebug = () => {
  const { authenticationState, dispatchAuthenticationAction } = useAuthentication();
  return (
    <JsonEditor
      {...createCallback(dispatchAuthenticationAction)}
      rootName='Authentication'
      data={authenticationState}
    />
  );
};
